import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { StringUtils, sortAscend } from '@ark-libs/ngx-utils';
import { AbstractDataService } from './abstract-data.service';


@Injectable({ providedIn:'root' })
export class UaaOfficeService extends AbstractDataService<any> {

    constructor( private injector: Injector ) {
        super(injector);
        this.ignoreHttpError = false;
    }

    private getData(url:string, params?:{[key:string]:any}): Promise<any>{
        return this.httpGet(url, params);
    }
    private getOffices(params:{parentId?:number,code?:string,officeType?:string,query?:string}): Promise<any[]> {
        return this.getData(this.apiUrls.offices, params).then(data=>{
            return data?data:[];
        });
    }
    
    getOffice(id:number): Promise<any> {
        return this.getData(this.apiUrls.offices+"/"+id);
    }
    getOfficeByCode(code:string): Promise<any> {
        return this.getOffices({code:code}).then(data=>{
            return data&&data.length>0?data[0]:null;
        });
    }

    getMyCommunityGroups(params?:{[key:string]:any}): Promise<any[]>{
        return this.getData(this.apiUrls.myCommunityGroups, params);
    }
    getMyCommunityRegions(office: any, params?:{[key:string]:any}): Promise<any[]>{
        if(office){
            if(!params) params = {};
            if(office.officeType=="BRANCH_REGION"){
                params["branchRegionId"] = office.id;
                params["communityGroupId"] = office.communityGroupId;
            }else if(office.officeType=="COMMUNITY_GROUP") params["communityGroupId"] = office.id;
        }
        return this.getData(this.apiUrls.myCommunityRegions, params);
    }
    getMyCommunities(office?: any, params?:{[key:string]:any}): Promise<any>{
        if(office){
            if(!params) params = {};
            if(office.officeType=="BRANCH_REGION"){
                params["branchRegionId"] = office.id;
                params["communityGroupId"] = office.communityGroupId;
            }else if(office.officeType=="COMMUNITY_GROUP") params["communityGroupId"] = office.id;
        }
        return this.getData(this.apiUrls.myCommunities, params).then(data=>{
            return data;
        });
    }
}
